module.exports = __webpack_public_path__ + "static/media/cp1.3a82cc4c.jpg";